import React from 'react'
import { MDXTag } from '@mdx-js/tag'
import {default as base} from 'mdx-deck/themes';
import style from 'react-syntax-highlighter/styles/prism/atom-dark';
import crystal from 'react-syntax-highlighter/languages/prism/crystal';
export const theme = {
  ...base,
  prism: {
    style,
    languages: {crystal},
  },
};
export const meta = {
	title: 'crystal tool implementationの話',
	event: {
		name: 'crystal.tokyo #9',
		url: 'https://crystal.connpass.com/event/128152/'
	},
	date: new Date('2019-05-13T00:00:00.000Z')
}

export default [
  ({ components, ...props }) => <MDXTag name="wrapper"  components={components}>

<MDXTag name="h1" components={components}><MDXTag name="inlineCode" components={components} parentName="h1">{`crystal tool implementation`}</MDXTag>{`の話`}</MDXTag>
<MDXTag name="h2" components={components}>{`さっき作った (@MakeNowJust)`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`自己紹介`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">
<MDXTag name="p" components={components} parentName="li">{`HN: さっき作った (make now just)`}</MDXTag>
<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul">{`GitHub: `}<MDXTag name="a" components={components} parentName="li" props={{"href":"https://github.com/MakeNowJust"}}>{`@MakeNowJust`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Twitter: `}<MDXTag name="a" components={components} parentName="li" props={{"href":"https://twitter.com/make_now_just"}}>{`@make_now_just`}</MDXTag></MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`最近は普通に大学生をしている`}</MDXTag>
</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`crystal tool implementation`}</MDXTag>{`とは？`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}><MDXTag name="inlineCode" components={components} parentName="h2">{`crystal tool implementation`}</MDXTag>{`とは？`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">
<MDXTag name="p" components={components} parentName="li"><MDXTag name="inlineCode" components={components} parentName="p">{`crystal tool 何とか`}</MDXTag>{`で使えるコマンドの 1 つ`}</MDXTag>
<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`crystal tool format`}</MDXTag>{`もこの仲間`}</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`メソッドの呼び出し位置から実装を検索できる`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`なんかエディタから使って定義位置へジャンプとかしたりできるらしい`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`使い方:`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-bash","metaString":""}}>{`\$ crystal tool implementation -c ファイル:行:列 エントリーファイル
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`例`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`foo.cr`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`def foo(x)
  p x
end

foo 42
`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-bash","metaString":""}}>{`\$ crystal tool implementation -c foo.cr:5:1 foo.cr
1 implementation found
/Users/makenowjust/foo.cr:1:1
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`例 (オーバーロード)`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`bar.cr`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`def bar(x : Int32)
end

def bar(x : String)
end

x = rand() < 0.5 ? 1 : "x"
bar x
`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-bash","metaString":""}}>{`\$ crystal tool implementation -c bar.cr:8:1 bar.cr
2 implementations found
/Users/makenowjust/bar.cr:1:1
/Users/makenowjust/bar.cr:4:1
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`便利そう 🤔`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`失敗例 (マクロ)`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`mac.cr`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`macro mac(x)
  p {{x}}
end

mac 42
`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-bash","metaString":""}}>{`\$ crystal tool implementation -c mac.cr:5:1 mac.cr
no implementations or method call found
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`失敗例 (呼び出されてないメソッドの中)`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`in-call.cr`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`def foo
  bar
end

def bar
end
`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-bash","metaString":""}}>{`\$ crystal tool implementation -c in-call.cr:2:3 in-call.cr
no implementations or method call found
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`上手くいかない例`}</MDXTag>
<MDXTag name="ol" components={components}>
<MDXTag name="li" components={components} parentName="ol">{`マクロ`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`呼び出されていないメソッドの中の呼び出し`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`クラスなどの型`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`型エイリアス`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`定数`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`メソッドの型制約`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`世知辛いのじゃ〜`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`進捗パート`}</MDXTag>
<MDXTag name="p" components={components}>{`ここ一週間くらい`}<MDXTag name="inlineCode" components={components} parentName="p">{`crystal tool implementation`}</MDXTag>{`を弄っていた。`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`上手くいかない例`}</MDXTag>
<MDXTag name="p" components={components}>{`色々直した。`}</MDXTag>
<MDXTag name="ol" components={components}>
<MDXTag name="li" components={components} parentName="ol">{`マクロ`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`呼び出されていないメソッドの中の呼び出し`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol"><MDXTag name="del" components={components} parentName="li">{`クラスなどの型`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ol"><MDXTag name="del" components={components} parentName="li">{`型エイリアス`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ol"><MDXTag name="del" components={components} parentName="li">{`定数`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`メソッドの型制約`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{"href":"https://github.com/crystal-lang/crystal/pull/7742"}}>{`https://github.com/crystal-lang/crystal/pull/7742`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`例 (型)`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`cls.cr`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`class Foo
end

Foo.new
`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-bash","metaString":""}}>{`\$ bin/crystal tool implementation -c cls.cr:4:1 cls.cr
Foo
1 implementation found
/Users/makenowjust/cls.cr:1:1
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`例 (型エイリアス)`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`als.cr`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-crystal","metaString":""}}>{`class Foo
end

class Bar
end

alias Baz = Foo | Bar

Baz
`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-bash","metaString":""}}>{`\$ bin/crystal tool implementation -c als.cr:9:1 als.cr
Baz
1 implementation found
/Users/makenowjust/als.cr:7:1
`}</MDXTag></MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`乞うご期待`}</MDXTag>
<MDXTag name="p" components={components}>{`まだマージされてないです`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{"href":"https://github.com/crystal-lang/crystal/pull/7742"}}>{`https://github.com/crystal-lang/crystal/pull/7742`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}>{`マージされるといいですね`}</MDXTag></MDXTag>,

({ components, ...props }) => <MDXTag name="wrapper"  components={components}><MDXTag name="h2" components={components}>{`上手くいかない例(展望)`}</MDXTag>
<MDXTag name="ol" components={components}>
<MDXTag name="li" components={components} parentName="ol">{`マクロ ← がんばればどうにか。`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`呼び出されていないメソッドの中の呼び出し ← 原理的に無理`}</MDXTag>
<MDXTag name="li" components={components} parentName="ol"><MDXTag name="del" components={components} parentName="li">{`クラスなどの型`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ol"><MDXTag name="del" components={components} parentName="li">{`型エイリアス`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ol"><MDXTag name="del" components={components} parentName="li">{`定数`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ol">{`メソッドの型制約 ← 大変そうだけど不可能じゃない？`}</MDXTag>
</MDXTag></MDXTag>
]